import { fontWeights, Paragraph, paragraphSizes } from '@va/ui/design-system';
import { ReactNode } from 'react';

type ReportBlockDisabledOverlayProps = {
  content?: ReactNode;
};

export const ReportBlockDisabledOverlay = ({ content }: ReportBlockDisabledOverlayProps) => {
  return (
    <div className='absolute top-0 left-0 w-full h-full backdrop-blur-2px flex justify-center items-center'>
      {content && typeof content === 'string' ? (
        <Paragraph size={paragraphSizes.large} weight={fontWeights.semibold} colorClassName='text-black-lighter-60'>
          {content}
        </Paragraph>
      ) : (
        content
      )}
    </div>
  );
};
